import * as Types from '../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type QuestionGroupMessageCommentFragment = { __typename: 'Comment', text: string, read: boolean, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type QuestionGroupMessageSystemMessageQuestionGroupUpdatedFragment = { __typename: 'SystemMessageQuestionGroupUpdated', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type QuestionGroupMessageSystemMessageQuestionTypeTransformedFragment = { __typename: 'SystemMessageQuestionTypeTransformed', questionNumber: number, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type QuestionGroupMessageSystemMessageStatisticsDeletedFragment = { __typename: 'SystemMessageStatisticsDeleted', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } };

export type QuestionGroupMessageFragment = QuestionGroupMessageCommentFragment | QuestionGroupMessageSystemMessageQuestionGroupUpdatedFragment | QuestionGroupMessageSystemMessageQuestionTypeTransformedFragment | QuestionGroupMessageSystemMessageStatisticsDeletedFragment;

export type QuestionGroupMessagesQueryVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
  questionGroupId: Types.Scalars['ID'];
}>;


export type QuestionGroupMessagesQuery = { __typename?: 'Query', pool: { __typename?: 'Pool', questionGroup?: { __typename?: 'QuestionSequence', messages: Array<{ __typename: 'Comment', text: string, read: boolean, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageQuestionGroupUpdated', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageQuestionTypeTransformed', questionNumber: number, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageStatisticsDeleted', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } | { __typename?: 'QuestionSeries', messages: Array<{ __typename: 'Comment', text: string, read: boolean, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageQuestionGroupUpdated', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageQuestionTypeTransformed', questionNumber: number, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageStatisticsDeleted', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } | { __typename?: 'SingleQuestion', messages: Array<{ __typename: 'Comment', text: string, read: boolean, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageQuestionGroupUpdated', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageQuestionTypeTransformed', questionNumber: number, id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } } | { __typename: 'SystemMessageStatisticsDeleted', id: string, createdAt: string, author: { __typename?: 'User', id: string, firstName: string, lastName: string } }> } | null } };

export const QuestionGroupMessageFragmentDoc = gql`
    fragment QuestionGroupMessage on Message {
  id
  createdAt
  author {
    id
    firstName
    lastName
  }
  __typename
  ... on Comment {
    text
    read
  }
  ... on SystemMessageQuestionTypeTransformed {
    questionNumber
  }
}
    `;
export const QuestionGroupMessagesDocument = gql`
    query QuestionGroupMessages($poolId: ID!, $questionGroupId: ID!) {
  pool(id: $poolId) {
    questionGroup(id: $questionGroupId) {
      messages {
        ...QuestionGroupMessage
      }
    }
  }
}
    ${QuestionGroupMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionGroupMessagesGQL extends Apollo.Query<QuestionGroupMessagesQuery, QuestionGroupMessagesQueryVariables> {
    document = QuestionGroupMessagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }